import { render, staticRenderFns } from "./TablePaginationCustom.vue?vue&type=template&id=6e0a7f04&"
import script from "./TablePaginationCustom.vue?vue&type=script&lang=js&"
export * from "./TablePaginationCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VPagination,VSelect,VSpacer})
